<div class="tooltip-pointer tooltip-pointer--{{ tooltipsService.placement }}">
    <svg width="14" height="5" viewBox="0 0 14 5" xmlns="http://www.w3.org/2000/svg">
        <path
            [attr.fill]="fill"
            d="M8.16248 4.16966C7.46708 4.66637 6.53292 4.66637 5.83752 4.16966L0 0L14 1.22392e-06L8.16248 4.16966Z"
        />
    </svg>
</div>
